import React from 'react';
import Helmet from 'react-helmet';
import {withPrefix} from 'gatsby';
import type {Node as ReactNode} from 'react';
import {useSiteMetadata} from '../../hooks';
import styles from './Layout.module.scss';
import Header from '../Header';
import CssBaseline from '@material-ui/core/CssBaseline';
import {ThemeProvider} from '@material-ui/styles';
import Viewport from '../Viewport';
import Footer from '../Footer';
import theme from '../../theme';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import GatsbyLink from 'gatsby-link';

type Props = {
    children: ReactNode,
    title: string,
    description?: string,
    socialImage?: string,
    mainPage?: string,
    location?: Object,
    pageTitle?: string,
    hideBreadcrumbs? :boolean
};

const Layout = ({children,
                    title,
                    description,
                    socialImage,
                    mainPage,
                    location,
                    pageTitle,
                    hideBreadcrumbs
                }: Props) => {
    const {author, url} = useSiteMetadata();
    const metaImage = socialImage != null ? socialImage : author.photo;
    const metaImageUrl = url + withPrefix(metaImage);
    const paths = location && location.pathname.split('/').filter(p => !!p);
    return (
        <>
            <Viewport/>
            <ThemeProvider theme={theme}>
                <CssBaseline/>
                <div className={styles.layout}>
                    <Helmet>
                        <html lang="en"/>
                        <title>{title}</title>
                        {/*<meta name="description" content={description} />*/}
                        {/*<meta property="og:site_name" content={title} />*/}
                        <meta name="robots" content="noindex"/>
                        {/*<meta property="og:image" content={metaImageUrl} />*/}
                        {/*<meta name="twitter:card" content="summary" />*/}
                        {/*<meta name="twitter:title" content={title} />*/}
                        {/*<meta name="twitter:description" content={description} />*/}
                        {/*<meta name="twitter:image" content={metaImageUrl} />*/}
                        <link
                            href="https://fonts.googleapis.com/css2?family=Red+Hat+Text:wght@400;500;700&display=swap"
                            rel="stylesheet"
                        />
                    </Helmet>
                    <Header mainPage={mainPage} location={location}/>
                    <div className={styles['layout__body']}>
                        {paths && paths.length > 0 && !hideBreadcrumbs && <Breadcrumbs separator={'>'}>
                            <GatsbyLink to='/'>
                                MAIN PAGE
                            </GatsbyLink>
                            {paths.map((path, ind) => (<GatsbyLink key={path} to={path}
                                                                   className={ind === paths.length - 1 ? styles['active'] : ''}>
                                {pageTitle}
                            </GatsbyLink>))}
                        </Breadcrumbs>}
                        {children}</div>
                    <Footer/>
                </div>
            </ThemeProvider>
        </>
    );
};

export default Layout;
